<script>
  import BaseDialogFormWrapper from '../../../components/dialog-form-wrapper';
  import eventBus from '../../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    props: {
      type: Number
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-import-table');
      },
    },
  }
</script>
